import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isTokenExpiringBeyond8Days } from "../utils/Auth";

// Only the token. Who the user is comes from decoding it (utils/Auth) and their profile from
// `currentUserLookup`; a `user` field here was never filled, and every token refresh reset it.
interface AuthState {
	token?: string;
}

const initialState: AuthState = {
	token: undefined,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		login: (state, action: PayloadAction<{ token: string }>) => {
			state.token = action.payload.token;
		},
		logout: (state) => {
			state.token = undefined;
			localStorage.removeItem("token");
		},
		checkTokenExpirationDate: (state) => {
			const expireToken = isTokenExpiringBeyond8Days();
			if (expireToken) {
				state.token = undefined;
				localStorage.removeItem("token");
			}
		},
	},
});

export const { login, logout, checkTokenExpirationDate } = authSlice.actions;

export default authSlice.reducer;
